
namespace TabAurous.Reports {
    export class QuarterlyReportOptions {
        items: Sales.SalesItemsRow[];
    }

    export class QuarterlyReportPanel extends Serenity.TemplatedPanel<WeeklyReportOptions> {
        constructor(container: JQuery, opt: WeeklyReportOptions) {
            super(container, opt);

            //Grouping
            var data: Sales.SalesItemsRow[] = this.options.items;
            var code = ["Month 1", "Month 2", "Month 3"];
            var grossamount = [0];
            grossamount.pop();
            var m1 = 0, m2= 0; var m3= 0;
            for (var i = 0; i < data.length; i++) {
                m1 += data[i].Month1;
                m2 += data[i].Month2;
                m3 += data[i].Month3;
            }
            var total = m1 + m2 + m3;
            m1 = parseFloat(((m1 / total) * 100).toFixed(2));
            m2 = parseFloat(((m2 / total) * 100).toFixed(2));
            m3 = parseFloat(((m3 / total) * 100).toFixed(2));
            grossamount.push(m1); grossamount.push(m2); grossamount.push(m3); 
            var options = {
                series: [{
                    name: 'Sales',
                    data: grossamount
                }],
                chart: {
                    height: 250,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: code,
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + "%";
                        }
                    }

                },
                title: {
                    text: 'Quarterly Sales Chart',
                    floating: true,
                    offsetY: 330,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            };
            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class QuarterlyReportEditor extends _Ext.GridEditorBase<Sales.SalesItemsRow> {
        protected getColumnsKey() { return "Sales.QuarterlySales"; }

        constructor(container: JQuery) {
            super(container);


        } 
        private chartContainer: JQuery;
        private chartPanel: QuarterlyReportPanel;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid(); 


            return grid;
        }
        public setdata(items: Sales.SalesItemsRow[],response) {
            this.setItems([]);
            for (let item of items) {
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);

            }

            this.onViewProcessData(response);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        } 
        onViewProcessData(response: Serenity.ListResponse<Sales.SalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new QuarterlyReportPanel(this.chartContainer, { items: response.Entities });

            return response;
        }
    }
}